export const cash = [
    {
        id: 0,
        name: "Fluxo de Caixa",
        description: "Relatório com todas as movimentações de entrada e saída que afetam o caixa do estabelecimento."
    },
    {
        id: 1,
        name: "Aportes e Sangrias",
        description: "Relatório com todos os aportes e sangrias realizados nos caixas durante a operação do estabelecimento."
    },
    {
        id: 2,
        name: "Recebimentos",
        description: "Relatório com a consolidação das vendas por tipo de recebimento no caixa."
    },
]